import { useEffect, useState } from 'react'
import { useUser } from '@/shared/hooks/use-user'

const COPIED_FEEDBACK_MS = 2000

export function useReferModal() {
  const { user, isLoading } = useUser()
  const referralCode = user?.referralCode ?? ''
  const [copied, setCopied] = useState(false)

  useEffect(() => {
    if (!copied) return
    const timeout = setTimeout(() => setCopied(false), COPIED_FEEDBACK_MS)
    return () => clearTimeout(timeout)
  }, [copied])

  async function copyCode() {
    if (!referralCode) return
    try {
      await navigator.clipboard.writeText(referralCode)
      setCopied(true)
    } catch {
      setCopied(false)
    }
  }

  return { referralCode, isLoading, copied, copyCode }
}
